import { initialiseApp } from "./game/app";

initialiseApp(window).catch((reason) => console.error(reason));
